/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  PaginationState,
  serializeObjectToQueryString,
  stringifyRequestQuery,
} from '../../../../../_metronic/helpers'
import {getEventsList} from './_requests'
import {useQueryRequest} from './QueryRequestProvider'
import { useQueryParams } from '../../../../../utils/utils'
import { useLocation } from 'react-router-dom'
import { defaultLimit } from '../../../../components/Table/components/pagination/UsersListPagination'
import { EventType } from '../table/columns/_columns_1'
import { useErrorHandler } from '../../../../../hooks/useErrorsHandler'

const QueryResponseContext = createResponseContext<EventType>(initialQueryResponse)
const QueryResponseProvider: FC = ({children}) => {
  const {state} = useQueryRequest()
  const {operatorId, user, gradeId, resourceId, maxAmount, minAmount, page, limit} = useQueryParams()

  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))

  const [errorMessage, setErrorMessage] = useState<string>('')
  const [response, setResponse] = useState<any>();

  const {
    isFetching,
    refetch,
    data: result,
    error
  } = useQuery(
    `get-events`,
    async () => {    
      setErrorMessage('')  
      const newQuery = serializeObjectToQueryString({operatorId, user, gradeId, resourceId, maxAmount, minAmount, limit: limit || defaultLimit, page: page || 1});
      return await getEventsList(newQuery)
    },
    {cacheTime: 0, retry: false, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  useEffect(() => {
    setResponse(result)
  }, [result])

  useErrorHandler(error, setErrorMessage, setResponse)

  const location = useLocation();

  useEffect(() => {
    refetch()
  }, [location]);

  return (
    <QueryResponseContext.Provider value={{isLoading: isFetching, refetch: () => {}, response, query, total: result?.total, errorMessage }}>
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const {response} = useQueryResponse()
  if (!response) {
    return []
  }

  return response?.data || []
}

const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {response} = useQueryResponse()
  if (!response || !response.payload || !response.payload.pagination) {
    return defaultPaginationState
  }

  return response.payload.pagination
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
